export const operatorControlConstants = {
	GetList: {
		REQUEST : 'GET_LIST_CONTROL_REQUEST',
		SUCCESS : 'GET_LIST_CONTROL_SUCCESS',
		FAILURE : 'GET_LIST_CONTROL_FAILURE'
	},
	CLEAR  : 'CLEAR_CONTROL',
	Create : {
		REQUEST : 'CREATE_CONTROL_REQUEST',
		SUCCESS : 'CREATE_CONTROL_SUCCESS',
		FAILURE : 'CREATE_CONTROL_FAILURE'
	},
	Update: {
		REQUEST : 'UPDATE_CONTROL_REQUEST',
		SUCCESS : 'UPDATE_CONTROL_SUCCESS',
		FAILURE : 'UPDATE_CONTROL_FAILURE'
	},
	Delete: {
		REQUEST : 'DELETE_CONTROL_REQUEST',
		SUCCESS : 'DELETE_CONTROL_SUCCESS',
		FAILURE : 'DELETE_CONTROL_FAILURE'
	},
	Restore: {
		SUCCESS : 'RESTORE_CONTROL_SUCCESS',
		REQUEST : 'RESTORE_CONTROL_REQUEST',
		FAILURE : 'RESTORE_CONTROL_FAILURE'
	},
	GetPaged: {
		REQUEST : 'GET_PAGED_CONTROL_REQUEST',
		SUCCESS : 'GET_PAGED_CONTROL_SUCCESS',
		FAILURE : 'GET_PAGED_CONTROL_FAILURE'
	},
	Find: {
		REQUEST : 'FIND_CONTROL_REQUEST',
		SUCCESS : 'FIND_CONTROL_SUCCESS',
		FAILURE : 'FIND_CONTROL_FAILURE'
	}

}